import { ConditionalCustomerFilterProvider } from "@dashboard/components/ConditionalFilter";
import { Route } from "@dashboard/components/Router";
import { sectionNames } from "@dashboard/intl";
import { asSortParams } from "@dashboard/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  vendorAddPath,
  vendorAddressesPath,
  VendorAddressesUrlQueryParams,
  vendorListPath,
  VendorListUrlQueryParams,
  VendorListUrlSortField,
  vendorOfferingsPath,
  vendorPath,
  vendorPayPalPaymentPath,
  VendorUrlQueryParams,
} from "./urls";
import VendorListViewComponent from "./views/VendorList";
import VendorAddressesViewComponent from "./views/VendorList/VendorAddresses";
import VendorCreateView from "./views/VendorList/VendorCreate";
import VendorDetailsViewComponent from "./views/VendorList/VendorDetails";
import VendorOfferings from "./views/VendorOfferings";
import VendorPayPalPayment from "./views/VendorPayPalPayment";

const VendorListView = () => {
  const qs = parseQs(location.search.substr(1)) as any;
  const params: VendorListUrlQueryParams = asSortParams(qs, VendorListUrlSortField);

  return (
    <ConditionalCustomerFilterProvider locationSearch={location.search}>
      <VendorListViewComponent params={params} />
    </ConditionalCustomerFilterProvider>
  );
};

interface VendorDetailsRouteParams {
  id: string;
}

const VendorDetailsView = ({
  location,
  match,
}: RouteComponentProps<VendorDetailsRouteParams>) => {
  const qs = parseQs(location.search.substr(1));
  const params: VendorUrlQueryParams = qs;

  return <VendorDetailsViewComponent id={decodeURIComponent(match.params.id)} params={params} />;
};

interface VendorAddressesRouteParams {
  id: string;
}

const VendorAddressesView = ({ match }: RouteComponentProps<VendorAddressesRouteParams>) => {
  const qs = parseQs(location.search.substr(1));
  const params: VendorAddressesUrlQueryParams = qs;

  return (
    <VendorAddressesViewComponent id={decodeURIComponent(match.params.id)} params={params} />
  );
};

export const VendorSection = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.vendors)} />
      <Switch>
        <Route exact path={vendorListPath} component={VendorListView} />
        <Route exact path={vendorOfferingsPath} component={VendorOfferings} />
        <Route exact path={vendorPayPalPaymentPath} component={VendorPayPalPayment} />
        <Route exact path={vendorAddPath} component={VendorCreateView} />
        <Route path={vendorAddressesPath(":id")} component={VendorAddressesView} />
        <Route path={vendorPath(":id")} component={VendorDetailsView} />
      </Switch>
    </>
  );
};